import { Box, Button, Grid, Input, Label } from 'TBM/OldSharedUI';
import { useLoop } from 'loop/context';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type FormData = {
  email: string;
  password: string;
  verificationCode: string;
};

export function ConfirmForgotPasswordForm() {
  const { client } = useLoop();
  const { t } = useTranslation('forgot-password');
  const router = useRouter();
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<FormData>({
    defaultValues: {
      // @ts-ignore
      email: router.query.email || '',
    },
  });

  const onSubmit = handleSubmit(async (formData) => {
    return client
      .confirmPassword({
        email: formData.email,
        password: formData.password,
        verificationCode: formData.verificationCode,
      })
      .then(() => (window.location.href = '/v2/signin?fromPasswordReset=1'))
      .catch(() => alert('Error confirming signup'));
  });

  return (
    <form onSubmit={onSubmit}>
      <Grid gridGap={6} mt={6} mb={6}>
        <Box>
          <Label mb={3}>{t('email')}</Label>
          <Input type="text" readOnly={false} {...register('email')} />
        </Box>
        <Box>
          <Label mb={3}>{t('verificationCode')}</Label>
          <Input type="text" {...register('verificationCode')} />
        </Box>
        <Box>
          <Label mb={3}>{t('newPassword')}</Label>
          <Input type="password" {...register('password')} />
        </Box>
        <Button type="submit" variant="accent" disabled={isSubmitting}>
          {t('changePassword')}
        </Button>
      </Grid>
      <Link href="/signup" passHref>
        <Box as="a" color="blueLight500" fontSize={1}>
          {t('backToSignup')}
        </Box>
      </Link>
    </form>
  );
}
